<template>
    <div class="jwplayerContainer">
        <div ref="jwplayer" class="jwplayerStandin">
            <div class="content">
                <span>Video wird initialisiert ...</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'JWPlayer',

        props: {
            options: {
                required: false,
                default() {
                    return null
                }
            }
        },

        data() {
            return {
                instance: null,
                error: false,
                state: 'idle',
                adState: 'idle'
            }
        },

        watch: {
            options(newVal) {
                if (typeof(newVal) != 'undefined' && newVal != null) {
                    this.$l.log('options has changed', newVal)
                    this.setup()
                }
            }
        },

        mounted() {
            this.$l.log('jwplayer is here', this.$vuejw)
            this.init()
        },
        methods: {

            init() {
                this.$jwcomp = this
                this.$jwplayer = this.$vuejw.jwplayer(this.$refs.jwplayer)

                this.$events.$on(['jwAdPlay', 'jwAdStarted'], this.onAdPlaying)
                this.$events.$on(['jwAdError', 'jwAdPause', 'jwAdError', 'jwAdComplete', 'jwAdSkipped'], this.onAdStopping)
                this.$events.$on(['jwAdPause'], this.onAdPaused)

                var self = this;

                window.addEventListener('message', function(event) {
                    if(event.data.action == 'requestCurrentPlayerPosition') {
                        const msg = {
                            action: 'currentPlayerPosition',
                            position: self.$jwplayer.getPosition()
                        }
                        console.log('sending',msg)
                        window.parent.postMessage(msg, '*')
                    }
                });
            },

            setup() {
                this.$jwplayer.setup(this.options)
                // .on('setupError', this.onEvent)
                // .on('ready', this.onEvent)
                    .on('all', this.onEvent)
            },

            onEvent() {
                if (typeof(arguments) != 'undefined' && arguments.length > 1) {

                    try {
                        if (arguments[0] != 'time') {
                            this.$l.log('jwevent', arguments)
                            // console.debug('jwevent', arguments)
                        }

                        var eventName = 'jw' + arguments[0][0].toUpperCase() + arguments[0].substring(1)

                        this.$events.$emit(eventName, arguments[1])
                    }
                    catch(e) {
                        debugger
                    }


                }

                this.updateState()
            },

            updateState() {
                this.state = this.$jwplayer.getState();
            },

            onAdPlaying() {
                this.adState = 'playing'
            },

            onAdPaused() {
                this.adState = 'paused'
            },

            onAdStopping() {
                this.adState = 'idle'
            }

        },

        events: {

            jwPlay() {
                this.updateState()
            },

            jwPause() {
                this.updateState()
            },

            jwBufferChange() {
                this.updateState()
            },

            jwBufferFull() {
                this.updateState()
            },

            jwIdle() {
                this.updateState()
            },

            jwComplete() {
                this.updateState()
            },

            jwError() {
                this.updateState()
            },

            fatalError(error) {

            }

        },

        beforeDestroy() {
            this.$jwplayer.remove()
        }
    }
</script>

<style lang="scss">

    .jwplayerStandin {

        position: relative;
        background: #000;
        color: #fff;

        &
        :before {
            display: block;
            content: "";
            /*width: 100%;*/
            padding-top: 9 / 16 *100%;
        }

        > .content {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;

            display: flex;
            align-items: center;
            justify-content: center;

        }

    }

</style>



// WEBPACK FOOTER //
// src/plugins/vue-jwplayer/JWPlayer.vue